import React, { useState } from 'react'
import { isMobile } from '../../../../utils'
import { Link } from 'react-router-dom'
import "./course-recommend.scss"

const CourseRecommend = ({hotCourses}) => {
    const [expanded, setExpanded] = useState(false)
    // 课程详情跳转链接
    const toCourse = (course) => `/course/${course.id}/${course.unit_id || 0}`
    // 移动端: 纵列推荐课程列表
    if (isMobile()) {
        // 无推荐数据时没有可收起的内容, 不展示折叠箭头
        const canToggle = hotCourses.length > 0
        if (canToggle) {
            return (
                <div className="course-recommend-m">
                    <div
                        className={`crm-header${canToggle ? ' crm-header--clickable' : ''}`}
                        aria-expanded={canToggle ? expanded : undefined}
                        onClick={() => canToggle && setExpanded((prev) => !prev)}
                    >
                        <span className="crm-title">推荐课程</span>
                        {canToggle && (
                            <span
                                className={`crm-toggle${expanded ? ' is-up' : ''}`}
                                aria-hidden="true"
                            >
                                {/* 展开时箭头朝上(点击收起), 收起时箭头朝下(点击展开) */}
                                <svg className="crm-toggle-icon" viewBox="0 0 12 12">
                                    <path
                                        d="M2.5 4.5 L6 8 L9.5 4.5"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.6"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                        )}
                    </div>
                    <div className={`crm-collapse${expanded ? '' : ' is-close'}`}>
                        <div className="crm-collapse-inner">
                            {canToggle ? (
                                <div className="crm-list">
                                    {hotCourses.map((course) => (
                                        <Link key={course.id} to={toCourse(course)} className="crm-item">
                                            <img
                                                className="crm-cover"
                                                src={course.cover || '/image/course.png'}
                                                loading="lazy"
                                            />
                                            <span className="crm-name">{course.title}</span>
                                        </Link>
                                    ))}
                                </div>
                            ) : (
                                <div className="crm-empty">暂无推荐课程</div>
                            )}
                        </div>
                    </div>
                </div>
            )
        } else {
            return null
        }
    }
    // PC端: 右侧栏竖排列表
    return (
        <div className="course-recommend">
            <div className="title">推荐课程</div>
            <div className="courses">
                {hotCourses.length > 0 ? (
                    <>
                        {hotCourses.map((course) => (
                            <Link key={course.id} to={toCourse(course)}>
                                <div className="course">
                                    <img
                                        src={course.cover || '/image/course.png'}
                                        alt={course.description}
                                    />
                                    <div className="name">{course.title}</div>
                                </div>
                            </Link>
                        ))}
                    </>
                ) : (
                    <p style={{ paddingLeft: '30px' }}>暂无推荐课程</p>
                )}
            </div>
        </div>
    )
}

export default CourseRecommend
